import { useRaven } from '@telecom/shared/composables/use-raven';
import { useRoute } from 'vue-router';
import type { TrackEventPayload } from '@telecom/shared/services/raven-service/raven-service';
import { TRACK_EVENT_TYPE } from '@/constants';
import { SpecificationJurisdiction } from '@/domains/specification/enums';
import * as TrackEvents from '@/constants/track-events';

export function useSpecificationTrack() {
    const { rvTrack: track } = useRaven();

    const route = useRoute();

    function rvTrack(eventCode: string, data: Partial<TrackEventPayload> = {}) {
        return track(eventCode, {
            otherParam: route.query.taskId as string,
            eventType: TRACK_EVENT_TYPE.Specification,
            sourceType: eventCode,
            ...data,
        });
    }

    /**
     * 根据管辖区触发对应的生成埋点
     *
     * @param jurisdiction - 管辖区
     */
    function trackGenerateByJurisdiction(jurisdiction: SpecificationJurisdiction) {
        if (jurisdiction === SpecificationJurisdiction.US) {
            rvTrack(TrackEvents.TRACK_EVENT_SPECIFICATION_US_GENERATE);
        }
        else if (jurisdiction === SpecificationJurisdiction.CN) {
            rvTrack(TrackEvents.TRACK_EVENT_SPECIFICATION_CN_GENERATE);
        }
        else if (jurisdiction === SpecificationJurisdiction.EU) {
            rvTrack(TrackEvents.TRACK_EVENT_SPECIFICATION_EU_GENERATE);
        }
    }

    return {
        rvTrack,
        trackGenerateByJurisdiction,
    };
}
